// Services
import breedService from "@/app/services/main/breed/breed-service.js"
import puppyPackService from "@/app/services/main/puppy-pack/puppy-pack-service.js"

// Constants
import { STATUS_CODES } from "@/app/constants/status-constants"

// Mixins
import { toastMessageMixins } from "@/app/mixins/utils/toast-message-mixins"
import { tableMixins } from "@/app/mixins/utils/table-mixins.js"

export default {
	name: "DoggyPacksListPage",
	mixins: [toastMessageMixins, tableMixins],
	data() {
		return {
			// Breed List
			breedList: [],
			breedId: "",
			addedBreedName: "",
			selectedBreed: "",

			selectedSize: "",
			sizeOptions: [
				{
					value: 2,
					name: "Small",
				},
				{
					value: 3,
					name: "Medium",
				},
				{
					value: 4,
					name: "Large",
				},
			],

			selectedAge: "",
			ageOptions: [
				{
					value: "P",
					name: "Puppy",
				},
				{
					value: "A",
					name: "Adult",
				},
			],

			selectedPriceOrder: "",
			priceOptions: [
				{
					value: "L",
					name: "Low to High",
				},
				{
					value: "H",
					name: "High to Low",
				},
			],

			puppyPacksList: [],
			puppyPacksTotalCount: 0,
			isShowMore: false,
			// Loading
			isAPILoading: true,
		}
	},

	async created() {
		await this.getBreedList()
	},

	mounted() {
		window.addEventListener("scroll", this.scrollToTop)
	},
	destroyed() {
		window.removeEventListener("scroll", this.scrollToTop)
	},

	computed: {
		displayShowMoreButton() {
			return this.puppyPacksTotalCount != this.puppyPacksList.length
		},
	},

	methods: {
		goBack(){
			const position = this.$store.getters.getCurrentPosition;
			if(position.y){
				const breederSysId = this.$store.getters.getPageBreederId;
				if (breederSysId)
					this.$router.push(`/puppy-for-sale?breedSysId=${breederSysId}`)
				else 
					this.$router.push("/puppy-for-sale")
			} else{
				this.$router.push("/")
			}
		},
		getTableContent(page = this.page, limit = this.limit, sortBy = this.sortBy, desc = this.desc) {
			this.getPuppyPacksList({ page, limit, sortBy, desc: true })
		},

		// Breed List
		getBreedList(val) {
			let size = val ? val : ""
			breedService
				.getBreedsBySize(size)
				.then((res) => {
					if (res.status === STATUS_CODES.SUCCESS) {
						let parsedBreeds = res.data.data
							.map((breed) => {
								if (breed.id !== 0) {
									return {
										...breed,
										status: "A",
									}
								}
							})
							.filter((data) => data)

						const range = val === 2 ? 2 : 1

						// if size is not defined or null or ""
						if ( size ) {
							const otherBreedOptions = parsedBreeds.slice(0, range)
							parsedBreeds = this.sortAlphabetically(parsedBreeds.slice(range, parsedBreeds.count))
							parsedBreeds = [...otherBreedOptions, ...parsedBreeds]
						}
						
						this.breedList = parsedBreeds
						
						this.setSelected(this.$route.query.breedId)
					} else {
						this.showAPIErrorToast(this.toastMessages.breed().ERROR_GET_BREED_TITLE, res)
					}

					this.isBreedsAPILoading = false
				})
				.catch(() => {
					this.showGenericErrorToast()
					this.isBreedsAPILoading = false
				})
		},

		createOptionBreed(breed) {
			this.addedBreedName = breed
			return { name: breed, id: `0-${breed}` }
		},

		setSelected(e) {
			if (!e) {
				this.page = 1
				this.breedId = ""
				this.onDropdownFilter("f_breedId", "")
				return
			}

			let selectedId = parseInt(e)
			const selectedBreed = this.breedList.filter((breed) => breed.id === selectedId)
			this.selectedBreed = selectedBreed

			this.breedId = selectedId
			this.isShowMore = false
			this.page = 1
			this.onDropdownFilter("f_breedId", selectedId)
		},

		async getPuppyPacksList(queryParams) {
			// search filters
			if (this.columnsFilter) {
				const { f_breedId, f_breedSizeId, f_age } = this.columnsFilter

				if (f_breedId) {
					queryParams["f_breedId"] = f_breedId
				}

				if (f_breedSizeId) {
					queryParams["f_breedSizeId"] = f_breedSizeId
				}

				if (f_age) {
					queryParams["f_age"] = f_age
				}
			}

			try {
				this.isAPILoading = true
				const response = await puppyPackService.getPuppyPacks(queryParams)
				if (response.status === STATUS_CODES.SUCCESS) {
					if (this.isShowMore) {
						this.puppyPacksList = [...this.puppyPacksList, ...response.data.data]
					} else {
						this.puppyPacksList = response.data.data
					}
					this.filterPrice(this.selectedPriceOrder)
					this.puppyPacksTotalCount = response.data.pagination.totalCount
					this.isAPILoading = false
				}
			} catch (error) {
				this.isAPILoading = false
			}
		},

		filterPrice(e) {
			if (!e) {
				return
			}

			if (e.name === "Low to High") {
				this.puppyPacksList = this.puppyPacksList.sort((a, b) => parseFloat(a.price) - parseFloat(b.price))
			} else {
				this.puppyPacksList = this.puppyPacksList.sort((a, b) => parseFloat(b.price) - parseFloat(a.price))
			}
		},

		showMore() {
			this.isShowMore = true
			this.onPageSelected("next")
		},

		setSelectedFilter(filterBy, e) {
			this.page = 1
			const val = e ? e.value : ""
			this.isShowMore = false
			this.onDropdownFilter(filterBy, val)

			if (filterBy === "f_breedSizeId") {
				if (e) {
					this.columnsFilter["f_breedId"] = ""
					this.$refs.sel.clearSelection()
				}
				this.getBreedList(val)
			}
		},

		hasProductImage(productImage) {
			let image = require("@/assets/images/_shared/dog-purchase.png")

			if (productImage) {
				image = productImage
			}

			return image
		},

		scrollToTop() {
			// Get the button
			let btnToTop = document.getElementById("btn-back-to-top")
			if (document.body.scrollTop > 300 || document.documentElement.scrollTop > 300) {
				btnToTop.style.display = "flex"
			} else {
				btnToTop.style.display = "none"
			}
		},
		backToTop() {
			document.body.scrollTop = 0
			document.documentElement.scrollTop = 0
		},

		replacePetName(description) {
			return description.replace(new RegExp("PET_NAME", "gi"), "your dog")
		},

		savePriceComputation(puppyPack) {
			let price = puppyPack.onSale ? puppyPack.salePrice : puppyPack.price

			let totalProductPrice = puppyPack.products.reduce((sum, i) => {
				return sum + i.price * i.quantity
			}, 0)

			let difference = totalProductPrice - parseFloat(price)

			return parseFloat(difference).toFixed(2)
		},

		sortAlphabetically(items) {
			const sortedItems = items.sort(function (a, b) {
				return a.name.localeCompare(b.name)
			})
			return sortedItems
		},
	},
}
